import graphql__474a0686af46674bbdf2 from "./__generated__/Slide_slide.graphql.js";import { forwardRef, useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import ResponsiveImage from "../Utils/ResponsiveImage";
import SlideCaption from "./SlideCaption";
import SlideContainer from "./SlideContainer";
import SlideOverlay from "./SlideOverlay";

const Slide = (props, ref) => {
  const slide = useFragment(Slide_slide, props.slide);
  const { image } = slide;

  const { slideIndex, setIsSlideFocused, onLoad, ...passthroughProps } = props;

  const refWithSlideIndex = useCallback(
    element => {
      if (ref) ref(element, slideIndex);
    },
    [ref, slideIndex]
  );

  const handleSlideFocused = useCallback(() => {
    setIsSlideFocused(true);
  }, [setIsSlideFocused]);

  const handleSlideBlurred = useCallback(() => {
    setIsSlideFocused(false);
  }, [setIsSlideFocused]);

  return (
    <SlideContainer
      {...passthroughProps}
      slide={slide}
      ref={refWithSlideIndex}
      onFocus={handleSlideFocused}
      onBlur={handleSlideBlurred}
    >
      <div className="slide-image-container d-flex justify-content-center">
        <SlideOverlay slide={slide} />
        <ResponsiveImage image={image} onLoad={onLoad} />
      </div>

      <SlideCaption slide={slide} />
    </SlideContainer>
  );
};

const Slide_slide = graphql__474a0686af46674bbdf2;

export default forwardRef(Slide);
